import { Account } from 'utils/contexts/AuthContext/AuthContextType';
import { ENV_OPS_EMAIL } from 'utils/constants';

type AccountToCheck = Pick<Account, 'email'>;

export const isEnvOpAccount = (account?: AccountToCheck) =>
    account?.email.includes(ENV_OPS_EMAIL) || false;
